import { render } from "./CatalogsViews.vue?vue&type=template&id=dc8d6ec6"
import script from "./CatalogsViews.vue?vue&type=script&lang=js"
export * from "./CatalogsViews.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__